import { SortValue } from '@/models/app-common.model';

export const getSortValue = ({ columnName, order }: SortValue): string => order ? `${columnName}:${order}` : '';
